/**
 * Imperativer Öffnungskanal für den globalen Nutri-Assistenten.
 *
 * Der `NutriAssistant`-FAB hält seinen Open-State lokal; damit andere
 * Oberflächen (Command-Palette, Onboarding, künftige Deep-Links) den
 * Chat öffnen können, ohne einen Context-Refactor zu erzwingen, läuft
 * das über ein DOM-CustomEvent. Der Assistent ist genau einmal pro
 * App-Shell gemountet (Layout.tsx) — ein globaler Event-Bus reicht.
 */

export const OPEN_NUTRI_ASSISTANT_EVENT = 'nutriflow:open-assistant';

/** Öffnet den globalen Nutri-Assistenten (No-op, falls nicht gemountet). */
export function requestOpenNutriAssistant(): void {
  window.dispatchEvent(new CustomEvent(OPEN_NUTRI_ASSISTANT_EVENT));
}
